import Store from 'lightningjs-redux';
import { getParentalLockStatus } from '../../../logic/user/user.selectors';

const mapControllers = instance => [
  {
    selector: getParentalLockStatus,
    callback: value => {
      instance.handlePopup(value);
    },
  },
];

export default Store.control(mapControllers);
